import { graphqlClient } from '../graphqlClient';

export const contactService = {
  saveMessage: async (input) => {
    const mutation = `
      mutation SaveContactMessage($input: CreateContactInput!) {
        saveContactMessage(input: $input) {
          id
          fullName
          email
          message
          createdAt
        }
      }
    `;
    return graphqlClient.mutate(mutation, { input });
  }
};
